import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { CancelAutoRenewTrialModalProps } from './CancelAutoRenewTrialModal.types';

export const renderCancelSubscriptionTrial = (data: CancelAutoRenewTrialModalProps) =>
    openPopupHelper({ popupName: popupNames.SUBSCRIPTION_CANCEL_TRIAL, data });
